import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router';

import NotFound from '@/pages/NotFound';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { RootState } from '@/store';

const UnprotectedLayout = () => {
  const { status } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const gxToken = useGxTokenFromStorage();
  const tripToken = useTripTokenFromStorage();

  if (status === 'failed') {
    if (!!gxToken && !!tripToken) {
      navigate('/logout');
      return null;
    }
    return <NotFound />;
  }
  return <Outlet />;
};

export default UnprotectedLayout;
